import { observer } from 'mobx-react-lite';
import PreviewTextElement from './PreviewTextElement';
import type { PreviewTextElementProps } from './types';

export type { PreviewTextElementProps };
export default observer(PreviewTextElement);
